import React from "react";
import "../EventGallery.css";

const DayOne2023 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2023/day1-2023/1.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/2.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/3.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/4.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/5.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/6.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/7.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/8.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/9.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/10.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/11.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/12.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/13.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/14.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/15.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/16.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/17.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/18.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/19.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/20.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/21.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/22.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/23.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/24.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/25.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/26.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/27.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/28.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/29.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/30.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/31.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/32.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/33.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/34.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/35.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/36.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/37.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/38.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/39.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/40.webp",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2023/day1-2023/41.webp",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2023 Day 1</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>
    </div>
  );
};

export default DayOne2023;